import React from 'react'
import {StyledContainer} from '@components/ui/container/style.ts'

interface ContainerProps {
    className?: string
    children: React.ReactNode
    fullWidth?: boolean
    hasContainer?: boolean
}

export const Container = ({children, className, fullWidth = false, hasContainer = true}: ContainerProps) => (
    <StyledContainer fullWidth={fullWidth} hasContainer={hasContainer} className={className}>
        {children}
    </StyledContainer>
)

Container.displayName = 'Container'
